<div class="profile-container">
  <div class="profile-content">
    <div class="personal-details">
      <div class="header-block">
        <div class="header-title">
          <app-breadcrumb></app-breadcrumb>
        </div>

      </div>

      <div class="template-block">
        <select name="" id="" [(ngModel)]="objectTemplateId" (change)="getObjectTemplateById($event)">
          <option value="" selected disabled> -- Asset Template--</option>
          <option value="{{list.objectTemplateId}}" *ngFor="let list of objectTemplateList">{{list.name}}</option>
        </select>
        <button class="">Get Data</button>
      </div>




      <table class="compare-table">
        <tr>
          <th class="key" style="width: 20%;">Specification</th>
          <th class="" style="width: 20%;">Input</th>
          <th *ngFor="let item of assets; let i = index">
            Option {{ i + 1 }}
          </th>
        </tr>

        <tr *ngFor="let key of displayKeys;let i = index">
          <td class="key">
            <div class="key-td">
              <span *ngIf="!key.isEdit">{{ key.key }}</span>
              <span *ngIf="key.isEdit"><input type="text" (keydown.escape)="key.isEdit = false" (blur)="updateKey(i)"
                  (keydown.enter)="updateKey(i)" [(ngModel)]=" key.key" class="compare-input"></span>
              <span>
                <i (click)="editClick(i)" class="bi bi-pencil-square"></i>
                <i (click)="removeKey(i)" style="margin-left: 5px;" class="bi bi-x-lg"></i></span>
            </div>
          </td>
          <td class=""><input type="text" [(ngModel)]=" key.value" class="compare-input"></td>
          <td *ngFor="let item of assets">
            <ng-container *ngIf="!isBoolean(item[key.key]); else boolTpl">
              {{ item[key.key] ?? '-' }}
            </ng-container>

            <ng-template #boolTpl>
              {{ item[key.key] ? '✔' : '✖' }}
            </ng-template>
          </td>
        </tr>
      </table>

      <div class="add-specification" *ngIf="objectTemplateId">
        <button type="button" (click)="addKey()">Add</button>
      </div>


      <!-- 
<div class="table-wrapper">

  <table class="compare-table" *ngIf="assets.length">

    <tr>
      <th class="sticky-col">Field</th>
      <th *ngFor="let item of assets; let i = index">
        Plot {{ i + 1 }}
      </th>
    </tr>

    <tr *ngFor="let key of displayKeys"
        [class.diff-row]="isDifferent(key)">

      <td class="label sticky-col">
        {{ toLabel(key) }}
      </td>

      <td *ngFor="let item of assets">
        <ng-container *ngIf="!isBoolean(item[key]); else boolTpl">
          {{ item[key] ?? '-' }}
        </ng-container>

        <ng-template #boolTpl>
          {{ item[key] ? '✔' : '✖' }}
        </ng-template>
      </td>

    </tr>

  </table>

</div> -->



    </div>
  </div>
</div>